import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { StyledContainer } from '@zillow/zrs-comet';
import RestrictedModal from './RestrictedModal';

import ListingApplicationsTab from './ListingApplicationsTab';
import { passthroughProp } from '../../utils/propTypes';
import OnBoarding from '../../components/OnBoarding/OnBoarding';
import Faqs from '../../components/Faqs/Faqs';
import { Heading, Page, PageBreadcrumb, PageContent, PageTitle, TextButton } from '@zillow/constellation';
import { ZRMUtils } from '@zg-rentals/rental-manager-header-navigation';

function ApplicationsTabPage({ listing, applicationsEnabled, isOnboardingPageViewed }) {
  const { city, state, street, unit, zip, listingAlias, isMultifamily } = listing;

  const formattedAddress = ZRMUtils.propertyUtils.formatAddress({
    street,
    city,
    state,
    unit,
    zip,
  });

  const completeFormattedAddress = formattedAddress.formattedCompleteAddress;
  const to = `/rental-manager/properties/${listingAlias}/${isMultifamily ? 'listing' : 'dashboard/overview'}`;
  const showOnboarding = !isOnboardingPageViewed && !applicationsEnabled;

  return (
    <>
      <RestrictedModal />
      <StyledContainer backgroundColor="white" className="App__wrapper">
        <Page backgroundColor="transparent">
          <PageBreadcrumb
            backButton={
              <TextButton as="a" href={to} buttonType="primary">
                {completeFormattedAddress}
              </TextButton>
            }
          />
          <PageTitle heading={<Heading level="1">Applications</Heading>} />
          <PageContent>
            {showOnboarding ? <OnBoarding /> : <ListingApplicationsTab listing={listing} />}
            <Faqs />
          </PageContent>
        </Page>
      </StyledContainer>
    </>
  );
}

ApplicationsTabPage.propTypes = {
  listing: passthroughProp(ListingApplicationsTab),
  applicationsEnabled: PropTypes.bool,
  isOnboardingPageViewed: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    app: state.app,
    listing: state.listing,
    user: state.user,
    applicationsEnabled: state?.user?.applicationsEnabled ?? false,
    isOnboardingPageViewed: state?.rentalApplication?.landlord?.isOnboardingPageViewed,
  };
}

const enhance = compose(withRouter, connect(mapStateToProps));

export default enhance(ApplicationsTabPage);
